<div class="tv-page flex h-full flex-col gap-6 py-8 px-10">
  <!-- Header: title left, live clock + date right -->
  <header class="flex items-center justify-between gap-6">
    <div class="flex items-center gap-4">
      <span class="material-icons tv-header-icon text-primary-light">calendar_month</span>
      <h1 class="tv-title font-bold uppercase tracking-wide text-text-primary">Heutige Liefertermine</h1>
      @if (werkLabel) {
        <span class="tv-date text-text-secondary">{{ werkLabel }}</span>
      }
    </div>
    <div class="flex items-center gap-5">
      <div class="flex items-center gap-3">
        <span class="material-icons tv-header-icon text-text-muted">schedule</span>
        <span class="tv-clock font-bold text-text-primary">{{ currentTime() }}</span>
      </div>
      <span class="h-10 w-px bg-white/15"></span>
      <span class="tv-date text-text-secondary">{{ currentDate() }}</span>
    </div>
  </header>

  <!-- Table -->
  <div class="glass-panel flex flex-1 flex-col overflow-hidden rounded-2xl">
    <div class="flex-1 overflow-auto">
      <app-delivery-date-table
        [rows]="pagedRows()"
        [loading]="loading()"
        [error]="error()"
        emptyMessage="Keine Liefertermine für heute."
        size="tv"
      ></app-delivery-date-table>
    </div>

    <!-- Pagination footer: same footer as the other tables, no arrows since this board never receives input. -->
    @if (rows().length > 0) {
      <div class="px-6 py-4 border-t border-white/10">
        <app-pagination
          [currentPage]="displayPage() + 1"
          [totalPages]="totalPages()"
          [totalItems]="rows().length"
          [pageSize]="pageSize"
          [showArrows]="false"
          [large]="true"
        ></app-pagination>
      </div>
    }
  </div>
</div>
